import { MoreVert } from '@mui/icons-material';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UseTableCellProps } from 'react-table';
import { PERMISSIONS } from 'shared/constants';
import { useQuoteListState } from 'shared/contexts/quotes-summary-context';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { useExportQuoteToPdfMutation } from 'shared/mutations/export-quote-to-pdf-mutation';
import { QuotesSummaryItem } from 'shared/types/quotesSummary';

export const QuoteSummaryContextMenuColumn = (props: UseTableCellProps<QuotesSummaryItem>) => {
  const userPermissions = useUserPermissions();
  const hasReviewPermissions = userPermissions.includes(PERMISSIONS['quoting.review']);
  const hasDeletePermissions = userPermissions.includes(PERMISSIONS['quoting.delete']);
  const {
    row: {
      original: { id, status, dateSubmitted },
    },
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const history = useHistory();
  const pdfMutation = useExportQuoteToPdfMutation({ quoteId: id, dateSubmitted });
  const { toggleDeleteDialog, setQuoteIdToDelete } = useQuoteListState();
  const isDraft = status === 'DRAFT';

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleReviewClose = () => {
    history.push(`/quoting/review/${id}`);
    setAnchorEl(null);
  };

  const handleCopyClick = () => {
    history.push(`/quoting/copy/${id}`);
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    history.push(`/quoting/edit/${id}`);
    setAnchorEl(null);
  };

  const handleExportToPDFClick = async () => {
    pdfMutation.mutate();
    setAnchorEl(null);
  };

  const handleDeleteClick = () => {
    setQuoteIdToDelete(id);
    toggleDeleteDialog();
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={handleReviewClose}
          disabled={isDraft || !hasReviewPermissions}
          title={hasReviewPermissions ? '' : 'You do not have permission to perform this action.'}
        >
          Review
        </MenuItem>
        <MenuItem onClick={handleEditClick}>Edit</MenuItem>
        <MenuItem onClick={handleExportToPDFClick}>Export to PDF</MenuItem>
        <MenuItem onClick={handleCopyClick}>Copy</MenuItem>
        <MenuItem
          onClick={handleDeleteClick}
          disabled={!hasDeletePermissions}
          title={hasDeletePermissions ? '' : 'You do not have permission to perform this action.'}
        >
          Delete
        </MenuItem>
      </Menu>
    </Grid>
  );
};
